import { Component, HostListener, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { CreateAuctionComponent } from 'src/app/features/rooms/component/createAuction/createAuction.component';
import { AuctionValidationService } from 'src/app/features/rooms/core/service/auction-validation.service';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';
import { RequestValidationsService } from '../../core/service/request-validations.service';
import { ItemRequestsService } from '../../core/service/item-requests.service';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Subscription } from 'rxjs';
import { CustomValidator } from 'src/app/shared/directives/custom.validator';

@Component({
  selector: 'app-submit-request',
  templateUrl: './submit-request.component.html',
  styles: [
  ]
})
export class SubmitRequestComponent {
  @HostListener('window:resize', ['$event'])

  reservePriceRequ = false;
  MainInfo_Form!: FormGroup
  Details_Photos_Form!: FormGroup
  Configration_Form!: FormGroup
  files: any[] = []
  isSubmitted: boolean = false
  Title: string = this._config.translate.instant('Auctions.Add Item for Auction');
  btnSubmit: string = "Add Item";
  loadingData: boolean = false
  loadingCategory: boolean = false
  MainImage: any
  loading: boolean = false;
  ToDay = new Date();
  Date_Min_Max: any = { min: null, max: null };
  categoriesList!: any[]
  TimeStartMax: any
  TimeEndMin: any;
  LoadingUploadBanner: boolean = false;
  LoadingUploadMedia: boolean = false;
  AuctionItemHaveEndTime: boolean = false;
  LoadTemplate: boolean = false;
  UseDefualtValues: boolean = true;
  subscriptions: Subscription[] = [];
  getScreenWidth: number = window.innerWidth;

  constructor(private fb: FormBuilder,
    private _RequestValidationsService: RequestValidationsService,
    private _ItemRequestsService: ItemRequestsService,
    @Inject(MAT_DIALOG_DATA) public data: { RequestID?: string, Title: string, ButtonText: string },
    public dialogRef: MatDialogRef<SubmitRequestComponent>,
    private _config: ConfigService,
    private dialog: MatDialog) {
    console.log(data);

  }

  ngOnInit() {
    this.Getcategories();
    if (this.data.RequestID) {
      // Update Request 
      this.GetRequest(this.data.RequestID);

    } else {
      // New Request
      this.MainInfo_Form = this.fb.group(this._RequestValidationsService.RequestMainInfoValidation())
      this.Details_Photos_Form = this.fb.group(this._RequestValidationsService.RequestDetails())
      this.Configration_Form = this.fb.group(this._RequestValidationsService.RequestConfigrations())
    }
  }

  hasError(formGroup: FormGroup, controlName: string, errorName: string) {
    return formGroup.controls[controlName].hasError(errorName);
  }

  get formDetailsControls() {
    return this.Details_Photos_Form.controls['details'] as FormArray<any>
  }

  getValidity(i: number, controlName: string, errorName: string) {
    return (<FormGroup>(<FormArray>this.Details_Photos_Form.get('details')).controls[i]).controls[controlName].hasError(errorName);
  }

  addDeatilsItem(defualtValue?: any) {
    (this.Details_Photos_Form.controls['details'] as FormArray).push(new FormGroup({
      key_en: new FormControl(defualtValue?.key_en || null, [CustomValidator.noWhiteSpace, Validators.maxLength(50)]),
      value_en: new FormControl(defualtValue?.value_en || null, [CustomValidator.noWhiteSpace, Validators.maxLength(50)]),
      key_ar: new FormControl(defualtValue?.key_ar || null, [CustomValidator.noWhiteSpace, Validators.maxLength(50)]),
      value_ar: new FormControl(defualtValue?.value_ar || null, [CustomValidator.noWhiteSpace, Validators.maxLength(50)]),
      is_new: new FormControl(true, [Validators.required])
    }));
  }

  removeDeatilsItem(index: number) {
    (this.Details_Photos_Form.controls['details'] as FormArray).removeAt(index);
  }

  Getcategories() {
    this.loadingCategory = true;
    this.subscriptions.push(this._ItemRequestsService.getCategories().subscribe(
      response => {
        this.loadingCategory = false;
        this.categoriesList = response.data.list
      },
      error => {
        this.loadingCategory = false;
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });
        this._config.showErrors(error);

      }
    ))
  }


  itemSelected: number = -1;
  dropping: boolean = false

  drop(event: any) {
    const array = this.Details_Photos_Form.value.details;
    moveItemInArray(array, event.previousIndex, event.currentIndex);
    this.Details_Photos_Form.setValue({ "details": array });
  }

  LoadCategoryTemplate(caregoryId: string) {
    this.LoadTemplate = true;
    this._ItemRequestsService.getCategorytemplate(caregoryId).subscribe({
      next: (res) => {
        this.LoadTemplate = false;
        // this.formBtnsControls.patchValue(res?.data?.btns)
        this.formDetailsControls.patchValue([]);
        res?.data?.templates.forEach((element: any) => {
          element.key_ar = element.name_ar
          element.key_en = element.name_en
          this.addDeatilsItem(element);
        });
      },
      error: (error) => {
        this.LoadTemplate = false;
        this._config.showErrors(error);
      },
    })
  }


  onSubmit() {
    if (this.loading) return;


    console.log(this.Configration_Form);
    if (this.MainInfo_Form.valid &&
      this.Details_Photos_Form.valid &&
      this.Configration_Form.valid &&
      this.MainImage.length) {
      let modal = {
        ...this.MainInfo_Form.value,
        ...this.Details_Photos_Form.value,
        ...this.Configration_Form.value,
        files: [this.MainImage[0], ...this.files]
      }

      modal.files[0].isMain = 1
      this.loading = true;

      if (this.data.RequestID) {
        this.OnUpdateRequest(modal)
      } else {
        this.OnCreateRequest(modal)

      }

    }
  }


  OnCreateRequest(modal: any) {
    this._ItemRequestsService.AddNewRequest(modal).subscribe({
      next: (res) => {
        // this._config.toastrService.success(this._config.translate.instant('items-requests.Request submited successfully'));
        this.dialogRef.close(true);

      },
      error: (err) => {
        this._config.showErrors(err);
        this.loading = false;


      }
    })
  }
  OnUpdateRequest(modal: any) {
    this._ItemRequestsService.UpdateRequest(modal, this.data.RequestID || '').subscribe({
      next: (res) => {
        // this._config.toastrService.success(res.message);
        // this._config.toastrService.success(this._config.translate.instant('items-requests.Updates submited successfully'));
        this.dialogRef.close(true);
      },
      error: (err) => {
        this._config.showErrors(err);
        this.loading = false;

      }
    })

  }

  GetRequest(id: string) {
    this.loadingData = true;
    this.subscriptions.push(this._ItemRequestsService.GetRequestById(id).subscribe({
      next: (res) => {

        this.loadingData = false;
        // this.RequestData = res.data;
        this.MainInfo_Form = this.fb.group(this._RequestValidationsService.RequestMainInfoValidation(res.data));
        this.Details_Photos_Form = this.fb.group(this._RequestValidationsService.RequestDetails(res.data));
        this.Configration_Form = this.fb.group(this._RequestValidationsService.RequestConfigrations(res.data));
        this.files = res.data.files.filter((file: any) => file?.isMain == 0);
        this.MainImage = res.data.files.filter((file: any) => file?.isMain == 1);
      },
      error: (error) => {
        this.loadingData = false;
        this._config.showErrors(error);
      }

    }))
  }
  get reserve_price() {
    return this.Configration_Form.get('reserve_price') as FormControl;
  }

  reservePrice() {

    this.reservePriceRequ = true;
    if (this.Configration_Form.value.is_reserve)
      this.reserve_price.setValidators([Validators.required])
    else
      this.reserve_price.setValidators(null)


    this.reserve_price.updateValueAndValidity();

  }


  onWindowResize(event: any) {
    this.getScreenWidth = event.target.innerWidth;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscriptions.forEach((subscription) => { subscription.unsubscribe(); });
  }
}
